export default __webpack_public_path__ + "static/case2-2acc50c14437aeec4736a7152fc75655.png";